"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelTransaction = void 0;
/* eslint-disable max-len */
var foundation_1 = require("@deqo/foundation");
var ModelOperation_1 = require("./ModelOperation");
// import { sha1 } from 'crypto-hash';
var logger = foundation_1.Logger.get('podopolis.stats');
var $cset = ModelOperation_1.ModelOperation.codes.$cset;
/**
 * Represents a transaction of changes applied to a ModelSnapshot.  A transaction can be considered to be pending or confirmed.  Pending
 * when it has not been confirmed and committed by the server to the shared model.  Confirmed when it has been confirmed, committed and
 * assigned a unique model version number.
 */
var ModelTransaction = /** @class */ (function () {
    // private cachedSignature?: string;
    function ModelTransaction(status, key, source, time, version, mode, reads, // TODO: Dedupe these
    writes) {
        this.status = status;
        this.key = key;
        this.source = source;
        this.time = time;
        this.version = version;
        this.mode = mode;
        this.reads = reads;
        this.writes = writes;
    }
    /**
     * Compiles a transaction signature for the specified write batch.
     *
     * @param writes
     */
    // public static async compileSignature(writes: ModelOperationBatch) {
    //     return await sha1(writes.map(ModelOperation.getFingerprint).join());
    // }
    /**
     * Creates a new ModelTransaction instance with the specified properties.
     *
     * @param status the transaction status.
     * @param key the key.
     * @param source the source.
     * @param time the time.
     * @param version the version.
     * @param mode the mode.
     * @param reads the reads.
     * @param writes the writes.
     */
    ModelTransaction.create = function (status, key, source, time, version, mode, reads, writes) {
        return new ModelTransaction(status, key, source, time, version, mode, reads, writes);
    };
    /**
     * Creates a new staged transaction from the specified raw inputs.
     *
     * @param key The key.
     * @param time The time.
     * @param reads The reads.
     * @param writes The writes.
     */
    ModelTransaction.createStaged = function (key, time, mode, reads, writes) {
        return new ModelTransaction(ModelTransaction.staged, key, null, time, -1, mode, reads, writes);
    };
    /**
     * Creates a single new pending transaction from one or more specified staged transactions.  If multiple transactions are provided, they
     * will combined using a roll and merge approach:
     *
     * Roll Phase:
     *
     * The objective of the roll phase is to "roll" a set of transactions into the fewest possible by culling transactions who's effects
     * would be entirely superseded by the next transaction in the sequence.  In order to be rolled, transactions must meet several criteria
     * designed to ensure no negative effects on intent (stuff not happening that was supposed to). The criteria for rolling are:
     *
     * 1. Rollable candidates must be explicitly marked as compatible (from an intent perspective) via the "rolling" mode property.
     * 2. Rollable candidates must be part of an action group, defined by the "key" property.
     * 3. Rollable candidates must be in the same action group as their roll target.  An action group is a set of transactions that make up
     *    a single user action, e.g. dragging an object from A to B.
     * 4. Rollable candidates must not contain any non-rollable moops (in reality anything other than csets).
     * 5. Rollable candidates must have a fingerprint exactly matching the following transaction (roll target).
     *
     * Following these rules means that most transactions will not be rolled, but noisy transaction sequences (such as a user dragging an
     * object from A to B which generates a unform sequence of csets only) will be rolled up into a single transaction.  This in effect will
     * reduce the network send, though is limited to the transaction cycle window.  Backend rolling also occurs to reduce storage space for
     * rollable transactions that span several transaction cycles.
     *
     * Merge Phase:
     *
     * Remaining transactions (none-rollables) are merged into a single transaction.  If there is a common mode it will be selected as the
     * mode, otherwise the mode will fallback to unit.  If there is a common key it will be used as the key, otherwise the key will fallback
     * to null.  Keys are not processed server-side so essentially this is inconsequential.
     *
     */
    ModelTransaction.createPending = function (staged) {
        var e_1, _a;
        var pending = ModelTransaction.pending, rolling = ModelTransaction.rolling;
        var collapsed = 0;
        // Roll; working backwards remove any rollable candidates from the buffer
        for (var i = staged.length - 1; i >= 1; i--) {
            var a = staged[i];
            var b = staged[i - 1];
            (0, foundation_1.assert)(a.status === ModelTransaction.staged, 'createPending: all input transactions must be staged.');
            (0, foundation_1.assert)(b.status === ModelTransaction.staged, 'createPending: all input transactions must be staged.');
            if (b.canRollInto(a)) {
                // Cull b to roll into a
                staged.splice(i - 1, 1);
                collapsed++;
            }
        }
        // Merge; working forwards, combine all reads and writes, take max time and set to unit if _any_ of the transactions are unit mode.
        var key = staged[0].key;
        var time = 0;
        var mode = rolling;
        var reads = [];
        var writes = [];
        try {
            for (var staged_1 = __values(staged), staged_1_1 = staged_1.next(); !staged_1_1.done; staged_1_1 = staged_1.next()) {
                var tx = staged_1_1.value;
                key = key === null ? null : (tx.key === key ? key : null);
                time = Math.max(time, tx.time);
                mode = Math.min(tx.mode, mode);
                reads = reads.concat(tx.reads);
                writes = writes.concat(tx.writes);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (staged_1_1 && !staged_1_1.done && (_a = staged_1.return)) _a.call(staged_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        logger.log('createPending: collapsed', collapsed, 'and kept', staged.length);
        return this.create(pending, key, null, time, -1, mode, reads, writes);
    };
    /**
     *
     * @param original the original (pending) transaction.
     * @param confirmedVersion the confirmed model version number.
     */
    ModelTransaction.createConfirmed = function (original, confirmedVersion) {
        return new ModelTransaction(ModelTransaction.confirmed, original.key, original.source, original.time, confirmedVersion, original.mode, original.reads, original.writes);
    };
    /**
     * Orders and merges the specified list of transactions into a single new transaction.
     *
     * @param transactions the transactions to merge.
     */
    ModelTransaction.merge = function (transactions, status) {
        var e_2, _a;
        var time = 0;
        // TODO: Make this work
        var mode = ModelTransaction.unit;
        var reads = [];
        var writes = [];
        try {
            for (var transactions_1 = __values(transactions), transactions_1_1 = transactions_1.next(); !transactions_1_1.done; transactions_1_1 = transactions_1.next()) {
                var tx = transactions_1_1.value;
                (0, foundation_1.assert)(tx.status !== ModelTransaction.confirmed, 'merge failure: confirmed transactions cannot be merged.');
                time = Math.max(time, tx.time);
                reads = reads.concat(tx.reads);
                writes = writes.concat(tx.writes);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (transactions_1_1 && !transactions_1_1.done && (_a = transactions_1.return)) _a.call(transactions_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return this.create(status, null, null, time, -1, mode, reads, writes);
    };
    /**
     * Creates a new ModelTransaction from the specified buffer of packed confirmed transaction data.
     *
     * @param data the data.
     */
    ModelTransaction.unpack = function (data) {
        return new (ModelTransaction.bind.apply(ModelTransaction, __spreadArray([void 0, ModelTransaction.confirmed, null], __read(data), false)))();
    };
    Object.defineProperty(ModelTransaction.prototype, "fingerprint", {
        get: function () {
            return this.writes.map(ModelOperation_1.ModelOperation.fingerprint).join();
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns an optimized version of this transaction.  Optimizing involves removing redundant writes from the write list.  For
     * example, if a write occurs to a property and later on another write occurs, the first write is essentially redundant and
     * can be removed.  Similarly, if an entity is created and then deleted, or if it is updated and then deleted, everything
     * except the delete can be removed.  This process speeds up the transaction execution but more importantly makes the
     * payload size of the packed transaction smaller.
     */
    ModelTransaction.prototype.optimize = function () {
        var writes = this.writes;
        // To optimize, we walk from the most recent to the least recent write and build a change profile for each entity.  If we
        // find changes that are candidates for removal based on the change profile so far, we remove them.  Once complete we
        // rebuild the write list from the pruned list.
        // Currently, we optimize for the following:
        // - Wasted mset
        // - Wasted cset
        var keep = new Map();
        var profiles = {};
        for (var i = writes.length - 1; i >= 0; i--) {
            var w = writes[i];
            var _a = __read(w, 2), code = _a[0], target = _a[1];
            if (!code || !target)
                continue;
            var tcp = profiles[target] || (profiles[target] = new ChangeProfile());
            // If is set, if prop is already set ignore else keep and mark as set
            if (code === $cset) {
                var key = w[2];
                if (tcp.sets.has(key)) {
                    continue;
                }
                tcp.sets.add(w[2]);
            }
            // If we got this far we should keep
            keep.set(w, true);
        }
        // Optimize by removing writes not kept
        var optimized = writes.filter(function (x) { return !!keep.get(x); });
        return ModelTransaction.create(this.status, this.key, this.source, this.time, this.version, this.mode, this.reads, optimized);
    };
    /**
     * Returns an transport ready array containing the transaction data.
     */
    ModelTransaction.prototype.pack = function () {
        return [this.time, this.version, this.mode, this.reads, this.writes];
    };
    // public async signature() {
    //     return this.cachedSignature ?? (this.cachedSignature = await ModelTransaction.compileSignature(this.writes));
    // }
    ModelTransaction.prototype[Symbol.iterator] = function () {
        return this.writes[Symbol.iterator]();
    };
    ModelTransaction.prototype.canRollInto = function (t) {
        // Comments here repeated from the jsdoc for createPending.
        // Rollable candidates must be explicitly marked as compatible (from an intent perspective) via the "rolling" mode property.
        if (this.mode !== ModelTransaction.rolling) {
            return false;
        }
        // Rollable candidates must be part of an action group, defined by the "key" property.
        if (!this.key) {
            return false;
        }
        // Rollable candidates must be in the same action group as their roll target.  An action group is a set of transactions that make
        // up a single user action, e.g. dragging an object from A to B.
        if (!this.key || this.key !== t.key) {
            return false;
        }
        // Rollable candidates must not contain any non-rollable moops (in reality anything other than csets).
        if (!!this.writes.find(function (x) { return x[0] !== $cset; })) {
            return false;
        }
        // Rollable candidates must have a fingerprint exactly matching the following transaction (roll target). a can be unit but b must be
        // rolling since b is the collapse candidate
        if (this.fingerprint !== t.fingerprint) {
            return false;
        }
        return true;
    };
    ModelTransaction.unit = 1;
    ModelTransaction.rolling = 2;
    ModelTransaction.staged = 1;
    ModelTransaction.pending = 2;
    ModelTransaction.confirmed = 3;
    __decorate([
        (0, foundation_1.lazy)()
    ], ModelTransaction.prototype, "fingerprint", null);
    return ModelTransaction;
}());
exports.ModelTransaction = ModelTransaction;
var ChangeProfile = /** @class */ (function () {
    function ChangeProfile() {
        this.created = false;
        this.deleted = false;
        this.sets = new Set();
    }
    return ChangeProfile;
}());
/*

Optmize code for later (?)

// To optimize, we walk from the most recent to the least recent write and build a change profile for each entity.  If we
// find changes that are candidates for removal based on the change profile so far, we remove them.  Once complete we
// rebuild the write list from the pruned list.

const keep = new Map<ModelOperation, boolean>();
const profiles = {} as Record<string, ChangeProfile>;

// Stage one:
// Backwards!

for (let i = writes.length - 1; i >= 0; i--) {
    const w = writes[i];
    const [code, target] = w;

    const cp = profiles[target] || (profiles[target] = new ChangeProfile());

    // If is truncate, we need to check this at the end
    if (code === $ctruncate) {
        continue;
    }

    // If deleted in the future don't keep anything
    if (cp.deleted) {
        continue;
    }

    // If is delete, mark as deleted from now and keep
    if (code === $xdelete) {
        cp.deleted = true;
        keep.set(w, true);
        continue;
    }

    // If is set, if prop is already set ignore else keep and mark as set
    if (code === $cset || code === $mset) {
        const key = w[2] as string;
        if (!cp.sets.has(key)) {
            cp.sets.add(w[2] as string);
            keep.set(w, true);
        }
        continue;
    }

    // If we got this far we should keep
    keep.set(w, true);
}

// Stage two:
// Forwards!

for (const w of writes) {
    const [code, target] = w;

    const cp = profiles[target] || (profiles[target] = new ChangeProfile());

    // If is create, we should record the creation
    if (code === $xcreate) {
        cp.created = true;
        continue;
    }

    // If is truncate, we need can now tell if this should remain or not.  If the subject (not target) is deleted later and not
    // created earlier, the truncate is required for the delete in which case we should keep it.  Note that for append/truncate
    if (code === $ctruncate) {
        if (!cp.created && cp.deleted) {
            keep.set(w, true);
        }
        continue;
    }
}
 */
